export default "__VITE_ASSET__DTxXz1FT__"